'use client'

import { Button } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import useAsyncButtonProps from '../../../hooks/useAsyncButtonProps'

type Props = {
  text: string
  url: string
  onClick: () => Promise<unknown>
  styling?: React.ComponentProps<typeof Button>['styling']
  testId?: string
}

const Action = ({ text, url, onClick, styling, testId }: Props) => {
  const isConversationsOfferRequestMessageApiUpdateEnabled = useFeatureSwitch(
    'web_platform_conversations_offer_request_message_api_update',
  )
  const buttonProps = useAsyncButtonProps(onClick)

  if (isConversationsOfferRequestMessageApiUpdateEnabled) {
    return (
      <Button
        {...buttonProps}
        text={text}
        size={Button.Size.Medium}
        styling={styling}
        testId={testId}
      />
    )
  }

  return (
    <Button
      text={text}
      url={url}
      data-method="put"
      size={Button.Size.Medium}
      styling={styling}
      testId={testId}
    />
  )
}

Action.Styling = Button.Styling

export default Action
